import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TamperEventFormComponent } from '@app/components/forms/tamper-event/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { TamperEvent, TamperEventCreate } from '@app/models/tamper-event.interface';
import { TamperEventHelperService } from '@app/services/helpers/tamper-event-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-tamper-event-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        TamperEventFormComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class TamperEventEditPage {
  public title = 'Tamper Event Edit';
  formValid = signal(false);
  formValue = signal<TamperEventCreate | null>(null);
  id: number;
  tamperEvent$: Observable<TamperEvent>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private tamperEventHelper: TamperEventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.tamperEvent$ = this.tamperEventHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.tamperEventHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['tamper-events', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
